import { render, staticRenderFns } from "./Mandates.vue?vue&type=template&id=51b2aa47"
import script from "./Mandates.vue?vue&type=script&lang=js"
export * from "./Mandates.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/mandates.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports